// extracted by mini-css-extract-plugin
export default {"zoomControls":"taa-z","zoomControlButton":"uaa-z","zoomBanner":"vaa-z","bannerButton":"waa-z","imageButton":"xaa-z","zoom":"yaa-z","zoomContent":"zaa-z"};